import {Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';
import {CesiumAdapterService} from '@src/app/services/cesiumAdapter21/cesium-adapter.service';
import {debounceTime, tap, throttle, throttleTime} from 'rxjs/operators';
import {asyncScheduler} from "rxjs";

@Component({
  selector: 'app-scene-rotation',
  templateUrl: './scene-rotation.component.html',
  styleUrls: ['./scene-rotation.component.scss']
})
export class SceneRotationComponent implements OnInit{

  @ViewChild('arrowImg', {static: false}) img: ElementRef;

  constructor(private adapter:CesiumAdapterService, private cd: ChangeDetectorRef) { }

  ngOnInit(){

    this.adapter.sceneRotated$.pipe(throttleTime(50, asyncScheduler, {trailing: true, leading: true}), tap(val => {
      this.setImageRotation(val);
    })).pipe(debounceTime(300)).subscribe((rotateSceneDegrees) => {
      this.cd.detectChanges();
    })
  }

  setSceneToNorth() {
    this.adapter.resetCameraToNorth();
    this.setImageRotation(this.adapter.northHeading);
    this.cd.detectChanges();
  }

  get isResetToNorthActive():boolean{
    return this.adapter.isNorthHeading;
  }
  private setImageRotation(val){
    if(this.img && this.img.nativeElement){
      this.img.nativeElement.style.rotate = -1*(val-this.adapter.northHeading) + 'deg';
      this.cd.detectChanges();
    }
  }
}
